import AxiosController from "../../authentication/AxiosController";

let exclusiveProductIdsCache = null;

export const getUserExclusiveProductIds = async (slug, lang, token) => {
  if (exclusiveProductIdsCache) {
    return exclusiveProductIdsCache;
  }

  try {
    const res = await AxiosController.get(
      `api/${slug}/${lang}/latest-exclusive-products/1`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const products = res.data?.[0]?.data || [];
    exclusiveProductIdsCache = products.map((product) => String(product.id));
    return exclusiveProductIdsCache;
  } catch {
    return [];
  }
};

export const clearExclusiveProductIdsCache = () => {
  exclusiveProductIdsCache = null;
};

export const isUserExclusiveProduct = async (
  slug,
  lang,
  token,
  productId
) => {
  const exclusiveProductIds = await getUserExclusiveProductIds(
    slug,
    lang,
    token
  );
  return exclusiveProductIds.includes(String(productId));
};

export const fetchProductDetails = async ({
  slug,
  lang,
  token,
  productId,
  exclusiveParam,
}) => {
  const request = (exclusive) =>
    AxiosController.get(`api/${slug}/${lang}/get-product/${productId}`, {
      headers: { Authorization: `Bearer ${token}` },
      params: exclusive ? { exclusive } : {},
    });

  if (exclusiveParam) {
    const res = await request(exclusiveParam);
    return { data: res.data, usedExclusive: true };
  }

  try {
    const res = await request();
    return { data: res.data, usedExclusive: false };
  } catch (error) {
    const exclusiveProductIds = await getUserExclusiveProductIds(
      slug,
      lang,
      token
    );

    if (!exclusiveProductIds.includes(String(productId))) {
      throw error;
    }

    const res = await request("1");
    return { data: res.data, usedExclusive: true };
  }
};

export const canBypassSaSkuForExclusiveProduct = async ({
  slug,
  lang,
  token,
  productId,
  exclusiveParam,
}) => {
  if (slug !== "sa" || !productId) {
    return false;
  }

  if (exclusiveParam === "1") {
    return true;
  }

  return isUserExclusiveProduct(slug, lang, token, productId);
};
